import React, { Component, useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import VendorHeader from "./../component/VendorHeader";
import VendorFooter from "./../component/VendorFooter";
import $ from "jquery";
import { API_BASE_URL } from "../utils/app_url";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import Sidebar from "../component/Sidebar";

const icon1 = require("./../assets/img/dashboard-icon.svg").default;
const icon2 = require("./../assets/img/info-icon.svg").default;
const icon3 = require("./../assets/img/app-icon.svg").default;
const icon4 = require("./../assets/img/payment-icon.svg").default;
const icon5 = require("./../assets/img/store-icon.svg").default;
const icon6 = require("./../assets/img/list-icon.svg").default;
const icon7 = require("./../assets/img/order-icon.svg").default;
const icon8 = require("./../assets/img/plan-icon.svg").default;
const icon9 = require("./../assets/img/logout-icon.svg").default;
const deleteIcon = require("./../assets/img/delete-icon.svg").default;
const uploadBtn = require("./../assets/img/search-btn.svg").default;
const bulletIcon = require("./../assets/img/bullet.svg").default;

const VendorDashboard = () => {
  const { user, setStoreData } = useAuth();
  const { selectedLanguage, langJson } = useLanguage();
  const navigate = useNavigate();
  const actionDivRef = useRef(null);

  const [loading, setLoading] = useState();
  const [dashboardDetails, setDashboardDetails] = useState();
  const [currentPlanName, setCurrentPlanName] = useState();

  const fetchPlanName = async (planId) => {
    try {
      const response = await fetch(`${API_BASE_URL}frontend/plans`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        const plan = responseData.data.find(item => parseInt(item?.id) === parseInt(planId));
        if (plan) {
          setCurrentPlanName(plan.name);
        }
      }
    } catch (error) {
      console.error("Error fetching plan name:", error);
    }
  };

  const fetchDashboard = async () => {
    try {
      const [dashRes, videosRes] = await Promise.all([
        fetch(`${API_BASE_URL}stores/dashboard`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.authorisation.token}`,
          },
        }),
        fetch(`${API_BASE_URL}stores/videos`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.authorisation.token}`,
          },
        }),
      ]);
      const dashData = await dashRes.json();
      const videosData = await videosRes.json();

      if (dashData.res === true) {
        setDashboardDetails(dashData.data);
        if (dashData.data?.store?.active_plan) {
          fetchPlanName(dashData.data?.store?.active_plan);
        }
        setStoreData({
          total_products: dashData.data?.total_products,
          total_videos: videosData.data?.data?.length || 0,
          active_plan: dashData.data?.store?.active_plan,
        });
      }
    } catch (error) {
      console.error("Error during Sign UP:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, []);

  useEffect(() => {
    const handleClickOutside = event => {
      if (!actionDivRef?.current?.contains(event.target)) {
        // Clicked outside the td, add your logic here
        // console.log("Clicked outside the td");
        // setSelectedId(null);
      }
    };
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div>
      <div className="dashHeader">
        <VendorHeader />
      </div>
      <div className="adminDash">
        <Sidebar />

        <div className="rightSide rightTop">
          <div className="dashHdn">
            <h2>{dashboardDetails?.store?.store_name}</h2>
            <h3>
              {langJson?.welcomeback}, {dashboardDetails?.store?.user?.name}
            </h3>
          </div>

          {currentPlanName && (
            <div style={{
              marginBottom: "25px",
              padding: "18px 20px",
              backgroundColor: "#fff",
              borderRadius: "10px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
              borderLeft: "5px solid #4a7ba7",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between"
            }}>
              <div>
                <p style={{ margin: "0 0 8px 0", fontSize: "12px", color: "#888", textTransform: "uppercase", letterSpacing: "0.5px", fontWeight: "600" }}>
                  {langJson?.currentplan || "Current Plan"}
                </p>
                <h4 style={{ margin: "0", fontSize: "20px", color: "#2c3e50", fontWeight: "600" }}>
                  {currentPlanName}
                </h4>
              </div>
              <button
                onClick={() => navigate("/plans-and-pricing")}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#4a7ba7",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: "500",
                  transition: "all 0.3s ease"
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = "#3a5f85"}
                onMouseLeave={(e) => e.target.style.backgroundColor = "#4a7ba7"}
              >
                {langJson?.upgradeplan || "Upgrade"}
              </button>
            </div>
          )}

          <div className="dashTop">
            <ul>
              <li>
                <h3>{dashboardDetails?.total_orders}</h3>
                <p>{langJson?.totalorders}</p>
                {/* <div className="dashDis">+11.2%</div> */}
              </li>
              <li>
                <h3>{dashboardDetails?.total_products}</h3>
                <p>{langJson?.totalproducts}</p>
                {/* <div className="dashDis">+11.2%</div> */}
              </li>
              <li>
                <h3>{dashboardDetails?.store?.currency} {dashboardDetails?.total_earnings}</h3>
                <p>{langJson?.totalearnings}</p>
                {/* <div className="dashDis">+11.2%</div> */}
              </li>
              <li>
                <h3>{dashboardDetails?.total_requests}</h3>
                <p>{langJson?.newrequests}</p>
              </li>
            </ul>
          </div>

          <div className="dashHdn">
            <h3>{langJson?.orders}</h3>
            <div className="dashRgt">
              {/* <input type="file" />
              <div className="upBtn"></div> */}
              <button onClick={() => navigate("/orders")}>{langJson?.allorders}</button>
            </div>
          </div>

          <div className="prdtTable">
            <table>
              <tr>
                <th>{langJson?.orderno}</th>
                <th>{langJson?.name}</th>
                <th>{langJson?.country}</th>
                <th>{langJson?.email}</th>
                <th>{langJson?.quantity}</th>
                <th>{langJson?.price}</th>
                <th>{langJson?.orderdate}</th>
                <th>{langJson?.status}</th>
              </tr>
              {dashboardDetails?.orders?.data?.map((item, index) => (
                <tr key={index}>

                  <td><span
                    style={{ color: "#007bff", cursor: "pointer", fontWeight: 600 }}
                    onClick={() => navigate(`/order/${item.id}`)}
                  >
                    {item.order_number}
                  </span></td>
                  <td>{item?.name}</td>
                  <td>{item?.country}</td>
                  <td>{item?.email}</td>
                  <td>{item?.quantity}</td>
                  <td>
                    {item?.currency ? item?.currency : "₹"}
                    {item?.total_amount}
                  </td>
                  <td>{item?.ordered_date}</td>
                  <td>{item?.status}</td>
                </tr>
              ))}
            </table>
          </div>

          <div className="dashHdn">
            <h3>{langJson?.products}</h3>
            <div className="dashRgt">
              {/* <input type="file" />
              <div className="upBtn"></div> */}
              <button onClick={() => navigate("/products")}>{langJson?.allproducts}</button>
            </div>
          </div>

          <div className="prdtTable">
            <table>
              <tr>
                {/* <th>
                  <input type="checkbox" />
                </th> */}
                <th>{langJson?.articleno}</th>
                <th>{langJson?.orderno}</th>
                <th>{langJson?.category}</th>
                <th>{langJson?.subcategory}</th>
                <th>{langJson?.season}</th>
                <th>{langJson?.unitprice}</th>
                <th>{langJson?.color}</th>
                <th>{langJson?.size}</th>
                <th>{langJson?.price}</th>
                <th>{langJson?.originalprice}</th>
                {/* <th>{langJson?.action}</th> */}
              </tr>
              {dashboardDetails?.products?.data?.map((item, index) => (
                <tr key={index}>
                  {/* <td>
                    <input type="checkbox" />
                  </td> */}
                  <td><span
                    style={{ color: "#007bff", cursor: "pointer", fontWeight: 600 }}
                    onClick={() => navigate(`/edit-product/${item.id}`)}
                  >
                    {item.article_no}
                  </span></td>
                  <td>{item?.order_no}</td>
                  <td>{item?.cat_info?.title}</td>
                  <td>{item?.pro_cat_info?.title}</td>
                  <td>{item?.season}</td>
                  <td>
                    {item?.currency} {item?.unit_price}
                  </td>
                  <td>{item?.color}</td>
                  <td>{item?.size}</td>
                  <td>
                    {item?.currency} {item?.price}
                  </td>
                  <td>
                    {item?.currency} {item?.sale_price}
                  </td>
                  {/* <td className="actionHolder">
                    <div>
                      <img src={bulletIcon} alt="" onClick={() => onBulletClick(item?.id)} />
                      {parseInt(selectedId) === parseInt(item?.id) ? (
                        <div className="actionDiv" ref={actionDivRef}>
                          <button onClick={() => navigate(`/edit-product/${item?.id}`)}>{langJson?.edit}</button>
                          <button onClick={() => handleDelete(item?.id)}>{langJson?.delete}</button>
                        </div>
                      ) : null}
                    </div>
                  </td> */}
                </tr>
              ))}
            </table>
          </div>
        </div>
      </div>
      <VendorFooter />
    </div>
  );
};

export default VendorDashboard;
